import ShoppingCartMenu from "@/abilities/shop/features/shop-core/components/menu-items/shopping-cart-menu.vue";
import { AbilityMenuEntries, MenuEntryWithMetaData } from "@/shared/environment/ability.types";
import { MenuContext } from "@/shared/environment/menu/menu.types";
import { Ref, ref, watchEffect } from "vue";

export function useToolBarMenuShopItems(menuContext: Ref<MenuContext>): AbilityMenuEntries {
    const menuEntries = ref<MenuEntryWithMetaData[]>([]);

    const getMenuEntries = (): MenuEntryWithMetaData[] => {
        if (menuContext.value.__type !== "toolbarMenuDetail") return [];

        return [
            {
                entry: {
                    id: "shopping-cart-menu",
                    component: {
                        getComponent: () => ShoppingCartMenu,
                        props: {
                            icon: "fa-regular fa-cart-shopping icon-color",
                            mobileIcon: "fa-regular fa-cart-shopping text-on-navbar-color",
                            menuTitleTranslationKey: "shared.Shopping cart",
                        },
                    },
                },
                position: "last",
            },
        ];
    };

    watchEffect(() => {
        menuEntries.value = getMenuEntries();
    });

    return { menuEntries };
}
